import type { IconData } from '@stacksjs/iconify-core'

export const eyeOpticSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 0a2 2 0 0 1 2 2v5.584a23.4 23.4 0 0 1 5.823 1.25l2.945-5.102a2 2 0 0 1 3.464 2l-2.748 4.76a23.6 23.6 0 0 1 5.22 3.978l3.853-3.853a2 2 0 0 1 2.828 2.829l-4.11 4.109a23.4 23.4 0 0 1 3.37 7.143a4.87 4.87 0 0 1 0 2.604C43.891 37.219 34.798 44.5 24 44.5S4.11 37.22 1.355 27.303a4.87 4.87 0 0 1 0-2.605a23.4 23.4 0 0 1 3.37-7.143l-4.11-4.11a2 2 0 0 1 2.829-2.828l3.853 3.853a23.6 23.6 0 0 1 5.22-3.978l-2.749-4.76a2 2 0 0 1 3.464-2l2.946 5.101A23.4 23.4 0 0 1 22 7.583V2a2 2 0 0 1 2-2m0 17.5a8.5 8.5 0 1 0 0 17a8.5 8.5 0 0 0 0-17\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default eyeOpticSolid
